/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

require('./bootstrap');

// External Frameworks
import Vuelidate from 'vuelidate'

import Vuex from 'vuex';

window.Vuex = Vuex;
Vue.use(Vuex);

Vue.use(Vuelidate);

import VModal from 'vue-js-modal'

Vue.use(VModal)